import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../i18n';
import { ToastContainer } from '../../components/Shared/ToastContainer';

interface PublicShellProps {
  children: ReactNode;
}

// Slim, marketing-style wrapper used only by /pricing and /kontakt.
// No app sidebar, no auth header — these pages must work without a session.
export function PublicShell({ children }: PublicShellProps) {
  const { t } = useTranslation(['public', 'common']);

  return (
    <div className="min-h-screen bg-paper flex flex-col">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between">
          <Link to="/pricing" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-[#00A871] rounded flex items-center justify-center text-white font-bold text-sm">
              FF
            </div>
            <span className="font-semibold text-[15px] text-slate-900 tracking-tight">
              FacilityFlow
            </span>
          </Link>
          <nav className="flex items-center gap-1">
            <Link
              to="/pricing"
              className="px-3 py-1.5 rounded-md text-[13px] font-medium text-slate-600 hover:bg-slate-50"
            >
              {t('public:shell.pricingLink')}
            </Link>
            <Link
              to="/kontakt"
              className="px-3 py-1.5 rounded-md text-[13px] font-medium text-slate-600 hover:bg-slate-50"
            >
              {t('public:shell.contactLink')}
            </Link>
            <Link
              to="/login"
              className="px-3 py-1.5 rounded-md text-[13px] font-medium text-white bg-[#00A871] hover:bg-emerald-700"
            >
              {t('public:shell.loginLink')}
            </Link>
          </nav>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-6xl mx-auto px-6 py-10">{children}</div>
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="max-w-6xl mx-auto px-6 py-4 text-[11px] text-slate-400 font-mono uppercase tracking-[0.18em]">
          FacilityFlow · v1.0
        </div>
      </footer>

      <ToastContainer />
    </div>
  );
}
